import { render, staticRenderFns } from "./NcrPage.vue?vue&type=template&id=3dc4e007&"
import script from "./NcrPage.vue?vue&type=script&lang=js&"
export * from "./NcrPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports